<template>
  <div>
    <w-title-bar :title="title" textColor="#000000"></w-title-bar>
    <div id="content" class="about_background content">
      <el-card class="content-position no-padding">
        <div class="clearfix header">
          <img class="my_head_background" src="static/product_head.png" />
          <img class="my_head" src="static/descOne.png" style="width:1.25rem" />
          <span style="font-family:PingFang">{{i18n.title_one}}</span>
        </div>
        <el-form :label-position="labelPosition" label-width="80px" :model="formIntroduction">
          <div style="font-family:PingFang">{{formIntroduction.descOne}}</div>
        </el-form>
      </el-card>

      <el-card class="content-position no-padding">
        <div class="clearfix header">
          <img class="my_head_background" src="static/product_head.png" />
          <img class="my_head" src="static/descTwo.png" />
          <span style="font-family:PingFang">{{i18n.title_two}}</span>
        </div>
        <el-form :label-position="labelPosition" label-width="80px" :model="formIntroduction">
          <div style="font-family:PingFang">{{formIntroduction.descTwo}}</div>
        </el-form>
        <img
          class="my_center_circle"
          :src="srcFlag?'static/uivs_center.png':'static/uivs_center_en.png'"
        />
      </el-card>

      <el-card class="content-position no-padding">
        <div class="clearfix header">
          <img class="my_head_background" src="static/product_head.png" />
          <img class="my_head" src="static/descThree.png" style="width:1rem" />
          <span style="font-family:PingFang">{{i18n.title_three}}</span>
        </div>
        <el-form :label-position="labelPosition" label-width="80px" :model="formIntroduction">
          <div style="font-family:PingFang">{{formIntroduction.descThree}}</div>
        </el-form>
        <div style="margin-top: 20px">
          <img class="icon-cooperation" src="static/jd.png" />
          <img class="icon-cooperation" src="static/wx.png" />
          <img class="icon-cooperation" src="static/yl.png" />
          <img class="icon-cooperation" src="static/al.png" />
        </div>
      </el-card>

      <el-card class="content-position no-padding" style="margin-bottom: 10px">
        <div class="clearfix header">
          <img class="my_head_background" src="static/product_head.png" />
          <img class="my_head" src="static/descFour.png" style="width:1.2rem" />
          <span style="font-family:PingFang">{{i18n.title_four}}</span>
        </div>
        <el-form :label-position="labelPosition" label-width="80px" :model="formIntroduction">
          <div style="font-family:PingFang">{{formIntroduction.descFour}}</div>
        </el-form>
        <div style="margin-top: 20px">
          <div class="my_padding">
            <img class="my_padding_pic" src="static/bottomOne.png" />
            <!-- <img class="my_padding_pic" src="static/bottomOne.jpg"/> -->
            <!-- <span class="demonstration">默认</span> -->
          </div>
          <div class="my_padding">
            <img class="my_padding_pic" src="static/bottomTwo.png" />
            <!-- <img src="static/bottomOne.jpg"/>
            <span class="demonstration">默认</span>-->
          </div>
          <div class="dot" style="display:inline-block"></div>
          <div class="my_bottom" style="width:43%;">{{i18n.wine}}</div>
          <div class="dot" style="display:inline-block"></div>
          <div class="my_bottom">{{i18n.e_commerce}}</div>
        </div>

        <div style="margin-top: 20px">
          <div class="my_padding">
            <img class="my_padding_pic" src="static/bottomThree.png" />
          </div>
          <div class="my_padding">
            <img class="my_padding_pic" src="static/bottomFour.png" />
          </div>
          <div class="dot" style="display:inline-block"></div>
          <div class="my_bottom" style="width:43%;">{{i18n.drug}}</div>
          <div class="dot" style="display:inline-block"></div>
          <div class="my_bottom">{{i18n.jewelry}}</div>
        </div>

        <div style="margin-top: 20px">
          <div class="my_padding">
            <img class="my_padding_pic" src="static/bottomFive.png" />
          </div>
          <div class="my_padding">
            <img class="my_padding_pic" src="static/bottomSix.png" />
          </div>
          <div class="dot" style="display:inline-block"></div>
          <div class="my_bottom" style="width:43%;">{{i18n.artwork}}</div>
          <div class="dot" style="display:inline-block"></div>
          <div class="my_bottom">{{i18n.dairy}}</div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import wTitleBar from "@/components/w-titleBar";
export default {
  name: "product",
  components: {
    wTitleBar,
  },
  data() {
    return {
      title: "",
      srcFlag: true,
      formIntroduction: {
        descOne: "",
        descTwo: "",
        descThree: "",
        descFour: "",
      },
    };
  },
  computed: {
    i18n() {
      this.title = this.$t("product.title");
      this.formIntroduction.descOne = this.$t("product.desc_one");
      this.formIntroduction.descTwo = this.$t("product.desc_two");
      this.formIntroduction.descThree = this.$t("product.desc_three");
      this.formIntroduction.descFour = this.$t("product.desc_four");
      return this.$t("product");
    },
  },
  mounted() {
    let divContent = document.getElementById("content").clientHeight;
    let screenHeight = document.body.clientHeight;
    document.getElementById("content").style.cssText =
      "height: " + (divContent - 44) + "px;";

    if (navigator.language.indexOf("zh") != -1) {
      this.srcFlag = true;
    } else {
      this.srcFlag = false;
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style >
.about_background {
  background-color: #f6f6f6;
}
.content {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.success_top {
  width: 100vw;
}
.success_center {
  width: 100vw;
  margin-top: -50%;
}
.text-pass {
  margin-top: -44%;
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(43, 27, 2, 1);
  line-height: 56px;
}
.text-test {
  font-size: 15px;
  text-align: center;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(208, 2, 27, 1);
  line-height: 37px;
}
.picture-position {
  margin-top: 18%;
  margin-left: 10px;
  margin-right: 10px;
  height: 250px;
  border-radius: 20px;
}
.image {
  width: 100%;
  display: block;
}
.content-position {
  margin-top: 2%;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
}
.my_head {
  width: 1.4rem;
  height: 1.3rem;
  margin-right: 5px;
  margin-top: -2px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-left: -240px;
}
.my_head_background {
  margin-left: -20px;
  height: 2.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.header {
  padding: 10px 0px;
  box-sizing: border-box;
  margin-top: -10px;
}
.no-padding {
  padding: 0px;
}
.el-carousel__item img {
  height: 200px;
  clear: both;
  display: block;
  margin: auto;
}
.my_center_circle {
  height: 12rem;
  transform: translate(35%, 9%);
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.icon-cooperation {
  height: 18%;
  width: 18%;
}
.my_padding {
  width: 48%;
  height: 5.6rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  opacity: 0.9;
  border: 1px solid rgba(222, 195, 148, 1);
  display: inline-block;
  /* margin-top: 1rem; */
}
.my_padding_pic {
  width: 70%;
  margin-left: 15%;
}
.my_bottom {
  display: inline-block;
  font-size: 10px;
  font-family:PingFang;
}
.dot {
  width: 12px;
  height: 12px;
  background: linear-gradient(
    180deg,
    rgba(251, 243, 230, 1) 0%,
    rgba(184, 137, 57, 1) 100%
  );
  box-shadow: 0px 2px 20px 0px rgba(193, 158, 97, 0.1);
  opacity: 0.7;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/product.vue